import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=21931f8e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=21931f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21931f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21931f8e')) {
      api.createRecord('21931f8e', component.options)
    } else {
      api.reload('21931f8e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=21931f8e&scoped=true&", function () {
      api.rerender('21931f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8HyQL0UOwUS3s/JS/comp/PopupDialog.vue"
export default component.exports